export default __webpack_public_path__ + "static/media/cont_item_03_2022_en.45d4df2e.svg";